import React, { useContext } from "react";
import { ClientsContext } from "../../App";

function ClientList() {
  const clientList = useContext(ClientsContext);
  return (
    <div className="w-full py-20 gap-y-10 flex flex-col items-center">
      <div className="w-4/5">
        <h2 className="text-base md:text-2xl tracking-wide">
          CHECK OUT WHAT OUR CLIENTS SAY ABOUT US
        </h2>
        <h1 className="text-3xl md:text-6xl">Testimonials</h1>
      </div>
      {clientList.map((client) => {
        return (
          <div
            key={client.id}
            className="w-full gap-y-10 flex flex-col items-center"
          >
            <div className="w-full py-10 md:py-20 gap-y-5 flex flex-col justify-center items-center text-3xl md:text-6xl bg-cyan-600 bg-opacity-50">
              <h1>{client.company}</h1>
              <h1 className="text-black text-center">{client.task}</h1>
            </div>
            <div className="w-11/12 md:w-4/5 p-5 md:p-20 flex items-center bg-white bg-opacity-20 rounded-xl shadow-lg">
              <div className="w-1/3">
                <img src="clients/task.png" alt="Task Logo" width={200} />
              </div>
              <div className="w-2/3 pr-10">
                <h2 className="text-2xl md:text-4xl text-black font-semibold">THE TASK</h2>
                <p className="pt-5 text-base md:text-2xl tracking-wide">
                  {client.taskDetail}
                </p>
              </div>
            </div>
            <div className="w-11/12 md:w-4/5 p-10 md:p-20 flex items-center bg-white bg-opacity-20 rounded-xl shadow-lg">
              <div className="w-1/3">
                <img
                  src="clients/solution.png"
                  alt="Solution Logo"
                  width={200}
                />
              </div>
              <div className="w-2/3 pr-10">
                <h2 className="text-2xl md:text-4xl text-black font-semibold">
                  THE SOLUTION
                </h2>
                <p className="pt-5 text-base md:text-2xl tracking-wide">
                  {client.solutionDetail}
                </p>
              </div>
            </div>
            <div className="w-11/12 md:w-4/5 p-5 md:p-20 flex items-center">
              <div className="w-2/3 pr-10">
                <h3 className="text-xl tracking-wide">COMPANY</h3>
                <h2 className="text-3xl md:text-6xl text-black font-semibold">
                  About the client
                </h2>
                <p className="pt-5 text-base md:text-2xl tracking-wide">
                  {client.aboutClient}
                </p>
              </div>
              <div className="w-1/3">
                <img src="" alt="Client Logo" />
              </div>
            </div>
            <div className="w-full py-10 gap-y-5 bg-black bg-opacity-20 flex flex-col justify-center items-center">
              <div className="w-11/12 md:w-4/5 text-xl md:text-4xl flex justify-center items-center">
                <p>{client.quote}</p>
              </div>
              <div className="w-11/12 md:w-4/5 text-base flex justify-end">
                <p>Mayank Joshi - An IT Solution Company</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ClientList;
